import classNames from "classnames";
import { useState } from "react";

import { Button, Text } from "@pentabd/ui";

import { ProfileInfoCard } from "@components";

import { useLanguage } from "@hooks/useLanguage";

import { enToBnNumber } from "@utils/enToBnNumber";

import { PositionType } from "@type/HRM/position";

const Position = ({
  position: { position, color, employee },
}: {
  position: PositionType;
}) => {
  const { language } = useLanguage();

  return (
    <div className="d-flex flex-row gap-5 justify-content-between">
      {employee.id ? (
        <ProfileInfoCard
          employee={employee as any}
          role={employee.type}
          weight="semibold"
        />
      ) : (
        <Text color="danger">----</Text>
      )}

      {position && position.id && (
        <Text
          size="xs"
          color={color}
          className={classNames({
            inactive: employee.id && !employee.isActive,
          })}
        >
          {language === "bn" ? position.nameBn : position.name}
        </Text>
      )}
    </div>
  );
};

const MyNode = ({ nodeData }: any) => {
  const [showPositions, setShowPositions] = useState(false);

  const { language } = useLanguage();

  const totalPosition = nodeData.positions.length;
  const filledPositions = nodeData.positions.filter(
    (position: any) => position.employee.id !== null,
  )?.length;

  return (
    <div key={nodeData.id} className="border border-info">
      <div className="d-flex flex-column">
        <Button
          type="primary"
          fill="fill"
          block
          size="sm"
          onClick={() =>
            nodeData.id !== "unit-unit-1" && setShowPositions((prev) => !prev)
          }
          className="p-0 px-4 py-2"
        >
          <Text size="sm">
            {language === "bn" ? nodeData.bnName : nodeData.label}
          </Text>
        </Button>

        {nodeData.id !== "unit-unit-1" && (
          <div className="text-info px-4 py-2">
            <Text size="sm">
              {language === "bn"
                ? `জনবল ${enToBnNumber(filledPositions)} / ${enToBnNumber(
                    totalPosition,
                  )}`
                : `Manpower ${filledPositions} / ${totalPosition}`}
            </Text>
          </div>
        )}
        {showPositions && (
          <div className="d-flex flex-column gap-10 align-items-left p-10">
            {nodeData.positions && totalPosition ? (
              nodeData.positions.map((position: PositionType) => (
                <Position position={position} />
              ))
            ) : (
              <></>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyNode;
